import React, { useEffect, useState } from 'react';
import Navbar from '../common/Navbar/Navbar';
import Footer from '../footer/Footer';
import { useLocation, useParams } from 'react-router-dom';
import VideoSlider from '../common/VideoSlider/VideoSlider';
import VideoCategoryPageHeader from './VideoCategoryPageHeader';
import { API_ENDPOINTS } from '../../assets/helpers/AssetHelpers';
import { CmsVideo } from '../../types/types';
import { getVideo } from '../../services/api/Api';
import SkeletonComponent from '../SkeletonComponent';
import SubNavbar from '../common/Navbar/SubNavbar';

const VideoCategoryPage = () => {
	const { category } = useParams();
	const location = useLocation();
	const [sliderVideoData, setSliderVideoData] = useState([]);
	const [mainTitle, setMainTitle] = useState('');
	const categoryId = category || '';
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchVideoData = async () => {
			setLoading(true);
			try {
				const response = await getVideo();
				const allCategories = response?.data;

				const matchedCategory = allCategories.find(
					(cat: { new_id: string }) => cat.new_id === category,
				);
				if (matchedCategory) {
					setMainTitle(matchedCategory.name || matchedCategory.category_name || '');
				}

				const categoryVideos = allCategories
					.filter((cat: { new_id: string }) => cat.new_id === category)
					.flatMap((cat: { cms_videos: any }) => cat.cms_videos || []);

				const formattedVideos = categoryVideos.map((video: CmsVideo) => {
					const videoTags: string[] = video.element_note.split(' ');
					const srcTag: string = videoTags.find((tag: string) => tag.includes('src')) || '';
					const videoUrlTagsArray: string[] = srcTag.split('/');
					const videoId = videoUrlTagsArray[videoUrlTagsArray.length - 1].split('?')[0];

					return {
						id: videoId,
						element_note: video.element_note,
						parent: video.parent,
						title: video.video_title,
						category: video.video_category,
						show_video_on_main_page: video.show_video_on_main_page,
						rootPageVideoRank:
							video.main_video_rank !== undefined ? Number(video.main_video_rank) : null,
						modified: video.modified,
						video_faq_id: video.faq_mapping_with_video_title,
						faq_category_hierarchy: video.faq_category_hierarchy,
					};
				});

				setSliderVideoData(formattedVideos);
			} catch (error) {
				console.error('Failed to fetch video data:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchVideoData();
	}, [category]);

	return (
		<>
			<Navbar />
      		<SubNavbar />
			<section id="videoSection">
				<div className="container">
					<div className="row">
						<div className="col py-4">
							<div className="row">
								<div className="col-lg-11 mx-auto px-4 px-md-5 px-lg-2">
									<div className="mb-4">
										<VideoCategoryPageHeader videoCategoryHeader={mainTitle} />
									</div>
									{loading ? (
										<SkeletonComponent name={'VideoSection'} />
									) : (
										<>
											<span className="ur_semi color1 fs-28">{mainTitle}</span>
											<VideoSlider
												videoData={sliderVideoData}
												buttonUrl="#"
												categoryId={mainTitle}
											/>
										</>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default VideoCategoryPage;
